// extracted by mini-css-extract-plugin
module.exports = {"root":"IntervalModifier_root__1GxZP","paper":"IntervalModifier_paper__3ciNU","entry":"IntervalModifier_entry__-7sqi","auto":"IntervalModifier_auto__utC1_"};